import React, { useEffect } from 'react';
import {useGlobalContext} from '../Utils/ContextApi';
import MovieCard from '../components/MovieCard/MovieCard';
import {motion} from 'framer-motion'
import {fetchData} from '../Utils/FetchData'
import { FaSearch } from 'react-icons/fa';

function Search(props) {
  const [input, setInput] = React.useState('');
  const {searchMovie, setSearchMovie} = useGlobalContext();
  const handle = async (e) => {
    e.preventDefault()
    try{
    if(input){
        const moviesData = await fetchData(`https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_API_KEY}&query=${input}`);
        console.log(moviesData)
        const movies = moviesData.filter((movie)=>{
            return movie.original_title.toLowerCase().includes(input)
        })
        setSearchMovie(moviesData)
        setInput('')
    }
  } catch(error){
    console.log(error)
  }
}

  return (
    <motion.div className='card-container'
    initial={{width:0}}
    animate={{width:"100%"}}
    exit={{x:window.innerWidth, transition: {duration:  0.1}}}>
      <div className='form-container'>
        <form className='form' onSubmit={handle}>
          <input 
            type='text'
            placeholder='Search For Movie'
            name={input}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{textTransform:"lowercase"}}
          />
          <button style={{cursor:'pointer'}}><FaSearch /></button>
        </form>
      </div>
      {searchMovie.map((item)=>{
        return(
          <MovieCard {...item} key={item.id}/>
        )
      })}
    </motion.div>
  )
}

export default Search